import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=86bcb30c&scoped=true&"
import script from "./CustomerAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bcb30c",
  null
  
)

export default component.exports